// eslint-disable-next-line
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Resume from './pages/Resume';
import Footer from './components/Footer';
import ResponsiveAppBar from './components/AppBar';
import { ThemeProvider, createTheme } from '@mui/material/styles';
const theme = createTheme({
  palette: {
    primary: {
      main: '#323643',
    },
    secondary: {
      main: '#00a8cc',
    },
  },
});
function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <ResponsiveAppBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="Home" element={<Home />} />
          <Route path="About" element={<About />} />
          <Route path="Projects" element={<Projects />} />
          <Route path="Resume" element={<Resume />} />
        </Routes>
        <Footer />
      </ThemeProvider>
    </>
  );
}

export default App;
